module.exports = __webpack_public_path__ + "img/ranged-icon.9ffd40cc.svg";